import React, { PureComponent } from "react";
import SideMenu from 'components/SideMenu';
import PlatformInfo from 'pages/aboutUs/platformInfo'
import CommonProblems from 'pages/aboutUs/commonProblems'
import LegalNotices from 'pages/aboutUs/legalNotices'
import ContactUs from 'pages/aboutUs/contactUs'
import { BrowserRouter as Router, Route,Redirect } from "react-router-dom";
require("./index.scss");


export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataList: [
        {
            txt: "平台简介",
            type:1,
            component:PlatformInfo,
            path: '/entrance/aboutUs/platformInfo'
          },
          {
            txt: "常见问题",
            type:2,
            component:CommonProblems,
            path: '/entrance/aboutUs/commonProblems'
          },
          {
            txt: "联系我们",
            type:3,
            component:ContactUs,
            path: '/entrance/aboutUs/contactUs'
          },
          {
            txt: "法律声明",
            type:4,
            component:LegalNotices,
            path: '/entrance/aboutUs/legalNotices'
          }
      ],
      navNum: '',
      active: 0,
      type:1,
      current:1,
      size:10,
      data:'',
    };
  }

  componentDidMount() {
      // this.getList()
  }



  render() {
    return (
      <div>
        {/* 内容 */}
        <div className="content">
          <div className="container clear">
              <SideMenu title={'关于我们'} data={this.state.dataList}/>
              <div className="content_list">
               
              {
                      this.state.dataList.map((item,index)=> {
                  
                          return(
                              <Route path={item.path} component={item.component} key={index}/>
                          )
                        
                      })
                }
              <Redirect from="/entrance/aboutUs" to="/entrance/aboutUs/platformInfo" />
                  
              </div>
          </div>
        </div>
        {/* 内容 */}
      </div>
    );
  }
}
